export function formatDKK(value: number | string | null | undefined): string {
    const num = typeof value === 'string' ? Number(value) : (value ?? 0);
    return new Intl.NumberFormat('da-DK', {
        style: 'currency',
        currency: 'DKK',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(Number(num));
}

export function formatPercent(value: number | string | null | undefined): string {
    const num = typeof value === 'string' ? Number(value) : (value ?? 0);
    return `${Number(num).toFixed(0)}%`;
}

export function toMonthKey(value: unknown): string | null {
    if (!value) return null;
    if (typeof value === 'string') {
        if (/^\d{4}-\d{2}/.test(value)) return value.slice(0, 7);
        const parsed = new Date(value);
        if (isNaN(parsed.getTime())) return null;
        return `${parsed.getFullYear()}-${String(parsed.getMonth() + 1).padStart(2, '0')}`;
    }
    // Firestore Timestamp (or any object exposing toDate()) from older records
    if (typeof (value as any).toDate === 'function') {
        const d = (value as any).toDate();
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
    }
    if (value instanceof Date) {
        return `${value.getFullYear()}-${String(value.getMonth() + 1).padStart(2, '0')}`;
    }
    return null;
}

export function formatDate(
    value: string | number | Date | null | undefined,
    style: 'short' | 'long' = 'short'
): string {
    if (value === null || value === undefined || value === '') return ''
    const date = value instanceof Date ? value : new Date(value)
    if (isNaN(date.getTime())) return ''
    const options: Intl.DateTimeFormatOptions =
        style === 'long'
            ? { day: '2-digit', month: 'long', year: 'numeric' }
            : { day: '2-digit', month: '2-digit', year: 'numeric' }
    return new Intl.DateTimeFormat('da-DK', options).format(date)
}
